// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-area-charts {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
}
@media (max-width: 992px) {
  .content-area-charts {
    grid-template-columns: 100%;
  }
}

.bar-chart {
  background-color: var(--secondary-color);
  padding: 16px 16px 6px 16px;
  border-radius: 5px;
  box-shadow: var(--light-shadow1);
  position: relative;
}
@media (max-width: 768px) {
  .bar-chart {
    padding: 12px;
  }
}
.bar-chart .bar-chart-wrapper {
  width: 100%;
  height: 240px;
}
@media (max-width: 1400px) {
  .bar-chart .bar-chart-wrapper .recharts-wrapper {
    margin-left: -10px;
  }
}
.bar-chart .bar-chart-info {
  margin-bottom: 32px;
}
.bar-chart .bar-chart-title {
  margin-bottom: 12px;
  font-size: 18px;
  font-family: "Cairo";
  font-weight: 700;
  color: var(--text-color-inverted);
}
.bar-chart .chart-info-data {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.bar-chart .info-data-value {
  color: var(--xl-text-color);
  font-size: 24px;
  font-family: "Cairo";
  font-weight: 700;
}
.bar-chart .info-data-text {
  display: flex;
  align-items: center;
  column-gap: 3px;
  color: var(--green-color);
}
.bar-chart .recharts-default-legend {
  position: absolute;
  top: -90px;
  right: 0;
}
.bar-chart .recharts-tooltip-label {
  color: var(--text-color-inverted);
  font-size: 14px;
  font-family: "Cairo";
  font-weight: 600;
}

.progress-bar {
  padding: 16px;
  border-radius: 5px;
  box-shadow: var(--light-shadow1);
  background: var(--secondary-color);
}
@media (max-width: 768px) {
  .progress-bar {
    padding: 12px;
  }
}
.progress-bar .progress-bar-title {
  font-size: 20px;
  font-weight: 700;
  font-family: "Cairo";
  color: var(--text-color-inverted);
  margin-bottom: 16px;
}
.progress-bar .bar-item-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 6px;
  margin-bottom: 8px;
}
.progress-bar .bar-item-info .bar-item-info-name,
.progress-bar .bar-item-info .bar-item-info-value {
  color: var(--text-color-inverted);
  font-weight: 600;
  font-family: "Cairo";
}
.progress-bar .progress-bar-list {
  display: grid;
  row-gap: 20px;
}
.progress-bar .bar-item-full {
  width: 100%;
  height: 10px;
  border-radius: 100vh;
  background-color: var(--chart-secondary-color);
  position: relative;
}
.progress-bar .bar-item-filled {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  border-radius: 100vh;
  background-color: var(--chart-primary-color);
}`, "",{"version":3,"sources":["webpack://./src/components/areaCharts/AreaCharts.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EALF;IAMI,2BAAA;EAEF;AACF;;AAEA;EACE,wCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AACF;AACE;EAPF;IAQI,aAAA;EAEF;AACF;AAAE;EACE,WAAA;EACA,aAAA;AAEJ;AAEM;EADF;IAEI,kBAAA;EACN;AACF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,mBAAA;EACA,eAAA;EACA,oBAAA;EAEA,gBAAA;EACA,iCAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,2BAAA;EACA,eAAA;EACA,oBAAA;EAEA,gBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAPJ;AAWE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AATJ;AAWE;EACE,iCAAA;EACA,eAAA;EACA,oBAAA;EAEA,gBAAA;AAVJ;;AAeA;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;EACA,kCAAA;AAZF;AAcE;EANF;IAOI,aAAA;EAXF;AACF;AAaE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EAEA,iCAAA;EACA,mBAAA;AAZJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAZJ;AAcI;;EAEE,iCAAA;EACA,gBAAA;EACA,oBAAA;AAZN;AAgBE;EACE,aAAA;EACA,aAAA;AAdJ;AAiBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8CAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,oBAAA;EACA,4CAAA;AAhBJ","sourcesContent":[".content-area-charts {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 16px;\n\n  @media (max-width: 992px) {\n    grid-template-columns: 100%;\n  }\n}\n\n// bar chart\n.bar-chart {\n  background-color: var(--secondary-color);\n  padding: 16px 16px 6px 16px;\n  border-radius: 5px;\n  box-shadow: var(--light-shadow1);\n  position: relative;\n\n  @media (max-width: 768px) {\n    padding: 12px;\n  }\n\n  .bar-chart-wrapper {\n    width: 100%;\n    height: 240px;\n\n    // recharts customization\n    .recharts-wrapper {\n      @media (max-width: 1400px) {\n        margin-left: -10px;\n      }\n    }\n  }\n\n  .bar-chart-info {\n    margin-bottom: 32px;\n  }\n\n  .bar-chart-title {\n    margin-bottom: 12px;\n    font-size: 18px;\n    font-family: \"Cairo\";\n\n    font-weight: 700;\n    color: var(--text-color-inverted);\n  }\n\n  .chart-info-data {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n  }\n\n  .info-data-value {\n    color: var(--xl-text-color);\n    font-size: 24px;\n    font-family: \"Cairo\";\n\n    font-weight: 700;\n  }\n\n  .info-data-text {\n    display: flex;\n    align-items: center;\n    column-gap: 3px;\n    color: var(--green-color);\n  }\n\n  // customization of recharts - bar chart\n  .recharts-default-legend {\n    position: absolute;\n    top: -90px;\n    right: 0;\n  }\n  .recharts-tooltip-label {\n    color: var(--text-color-inverted);\n    font-size: 14px;\n    font-family: \"Cairo\";\n\n    font-weight: 600;\n  }\n}\n\n// progress chart\n.progress-bar {\n  padding: 16px;\n  border-radius: 5px;\n  box-shadow: var(--light-shadow1);\n  background: var(--secondary-color);\n\n  @media (max-width: 768px) {\n    padding: 12px;\n  }\n\n  .progress-bar-title {\n    font-size: 20px;\n    font-weight: 700;\n    font-family: \"Cairo\";\n\n    color: var(--text-color-inverted);\n    margin-bottom: 16px;\n  }\n  .bar-item-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: 6px;\n    margin-bottom: 8px;\n\n    .bar-item-info-name,\n    .bar-item-info-value {\n      color: var(--text-color-inverted);\n      font-weight: 600;\n      font-family: \"Cairo\";\n\n    }\n  }\n  .progress-bar-list {\n    display: grid;\n    row-gap: 20px;\n  }\n\n  .bar-item-full {\n    width: 100%;\n    height: 10px;\n    border-radius: 100vh;\n    background-color: var(--chart-secondary-color);\n    position: relative;\n  }\n\n  .bar-item-filled {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 0;\n    border-radius: 100vh;\n    background-color: var(--chart-primary-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
